$ = jQuery;

$(document).ready(function($) {
    var header = $('header');
    var headerHeight = header.outerHeight();
    var altHeader = $('.event-alternative-header');
    var altHeaderDefault = $('.default-alternative-header');
    var headerSearchButton = $('header .header-wrapper .search-wrapper .btn-search');
    var headerSearchForm = $('header .header-wrapper .search-wrapper');
    var headerSearchClose = $('header .header-wrapper .search-wrapper .search-form-wrapper .close');
    var headerUserDropdown = $('header .header-wrapper .top-head #logged-in .nav-dropdown-menu');
    var headerUserDefault = $('header .header-wrapper #logged-in .nav-dropdown-menu');
    var hamburgerMenu = $('.hamburger-dropdown');
    var hamburgerTrigger = $('header .hamburger-menu');
    var hamburgerClose = $('.hamburger-dropdown .close');
    var postsSlider = $('.posts-slider');
    var productsSliderMultiple = $('.featured-products-slider.multiple');
    var productsSliderDouble = $('.featured-products-slider.double');

    $(window).on('scroll', function (e) {
        if($(window).scrollTop() >= headerHeight) {
            altHeader.addClass('sticky');
        } else {
            altHeader.removeClass('sticky');
        }
    });

    $(window).on('scroll', function (e) {
        if($(window).scrollTop() >= headerHeight) {
            altHeaderDefault.addClass('sticky');
        } else {
            altHeaderDefault.removeClass('sticky');
        }
        $(headerUserDefault).removeClass('active');
    });

    if($('header .header-wrapper .top-head').length > 0) {
        $(headerSearchButton).on('click', function(e){
            e.preventDefault();
            $(headerSearchForm).toggleClass('active');
        });
        $(headerSearchClose).on('click', function(e){
            e.preventDefault();
            $(headerSearchForm).toggleClass('active');
        });
        $(hamburgerTrigger).on('click', function(e){
            e.preventDefault();
            $(hamburgerMenu).toggleClass('active');
        });
        $(hamburgerClose).on('click', function(e){
            e.preventDefault();
            $(hamburgerMenu).toggleClass('active');
        });

        $(window).on('resize', function(){
            $(headerSearchForm).removeClass('active');
            $(headerUserDropdown).removeClass('active');
            $(headerUserDefault).removeClass('active');
            // $(hamburgerMenu).removeClass('active');
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('header .header-wrapper #logged-in').length) {
                $(headerUserDropdown).removeClass('active');
                $(headerUserDefault).removeClass('active');
            }
        });
    }

    //Mobile Items Slider
    if($(postsSlider).length) {
        var windowWidth = $(window).width();

        if (windowWidth > 768) { // If mobile and slider not built yet = build
            $(postsSlider).owlCarousel('destroy');
            $(postsSlider).removeClass("owl-carousel");
        } else {
            $(postsSlider).owlCarousel({
                // center: true,
                dots: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        loop: true,
                        autoWidth: true,
                        margin: 20,
                        items: 2,
                    }
                }
            });

            $(postsSlider).addClass("owl-carousel");
        }

        $(window).on('resize', function () {
            var windowWidth = $(window).width();

            if (windowWidth <= 768) {
                $(postsSlider).owlCarousel({
                    // center: true,
                    dots: false,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            loop: true,
                            autoWidth: true,
                            margin: 20,
                            items: 2,
                        }
                    }
                });

                $(postsSlider).addClass("owl-carousel");
            } else {
                $(postsSlider).owlCarousel('destroy');
                $(postsSlider).removeClass("owl-carousel");
            }
        })
    }

    //Products Slider Multiple
    if($(productsSliderMultiple).length) {
        $(productsSliderMultiple).owlCarousel({
            // center: true,
            responsiveClass: true,
            responsive: {
                0: {
                    loop: false,
                    autoWidth: true,
                    margin: 30,
                    items: 3,
                }
            }
        });
        $(productsSliderMultiple).addClass("owl-carousel");
    }

    //Products Slider Double
    if($(productsSliderDouble).length) {
        $(productsSliderDouble).owlCarousel({
            // center: true,
            responsiveClass: true,
            responsive: {
                0: {
                    loop: true,
                    autoWidth: true,
                    margin: 30,
                    items: 2,
                }
            }
        });
        $(productsSliderDouble).addClass("owl-carousel");
    }

	// Long Article template sidebar highlighting
	// Only needed on long article template
	// Pulled from Modern Retail; could be standardized.

	var mainNavLinks = document.querySelectorAll('.sections-nav li a');

	window.addEventListener('scroll', function () {
		var fromTop = window.scrollY;

		mainNavLinks.forEach(function (link) {
			var section     = document.querySelector(link.hash);
			var nextLink    = link.hash.split('-');
			var nextSection = document.querySelector(
				nextLink[0]+'-'+(parseInt(nextLink[1], 10) + 1)
			);
			if (
				section.offsetTop <= fromTop + 110
				// section.offsetTop + section.offsetHeight > fromTop + 110
				&& (null === nextSection || nextSection.offsetTop > fromTop + 110)
			) {
				link.classList.add('active');
			} else {
				link.classList.remove('active');
			}
		});
	});

	$('.sections-nav li a[href^="#"]')
		.not('.sections-nav li.scrollup')
		.on('click', function (e) {
			var target = e.target.parentNode.hash;
			e.preventDefault();
			target = $(target);
			$('html, body').stop().animate({
				scrollTop: target.offset().top - 80,
			}, 500, function () {
			});
		});

});
